import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { Grid, Button, Box, Typography } from '@mui/material';
import { v4 as uuidv4 } from 'uuid';

import { Template, TemplateBuilder } from '../../common/components';
import {
	getCharacterTemplate,
	createCharacterTemplate,
	updateCharacterTemplate,
} from './../../common/services/characterRequests';
import { createAlienTemplate } from './../../common/gameSystems/templates';
import { GAME_SYSTEM_NAMES } from '../../common/gameSystems/registry';

const CharacterTemplate = () => {
	const defaultTemplate = {
		name: 'Template Name',
		version: '1.0',
		gameSystem: GAME_SYSTEM_NAMES.ROBOTTA,
		isPublic: true,
		sections: [
			{
				id: 1,
				name: 'Info',
				type: 'text',
				elements: [
					{ id: uuidv4(), label: 'Nombre' },
					{ id: uuidv4(), label: 'Especie' },
					{ id: uuidv4(), label: 'Clase' },
					{ id: uuidv4(), label: 'Profesión' },
					{ id: uuidv4(), label: 'Estamento' },
					{ id: uuidv4(), label: 'Profesiones anteriores' },
					{ id: uuidv4(), label: 'Estatus' },
					{ id: uuidv4(), label: 'Edad' },
					{ id: uuidv4(), label: 'Altura' },
					{ id: uuidv4(), label: 'Peso' },
					{ id: uuidv4(), label: 'Color' },
					{ id: uuidv4(), label: 'Color Ojos' },
				],
			},
			{
				id: 2,
				name: 'Caracteristicas',
				type: 'number',
				elements: [
					{ id: uuidv4(), label: 'HA' },
					{ id: uuidv4(), label: 'HP' },
					{ id: uuidv4(), label: 'F' },
					{ id: uuidv4(), label: 'R' },
					{ id: uuidv4(), label: 'Int' },
					{ id: uuidv4(), label: 'Ag' },
					{ id: uuidv4(), label: 'Des' },
					{ id: uuidv4(), label: 'I' },
					{ id: uuidv4(), label: 'V' },
					{ id: uuidv4(), label: 'Em' },
				],
			},
		],
	};

	const { templateId } = useParams();
	const [template, setTemplate] = useState(defaultTemplate);

	useEffect(() => {
		const fetchTemplate = async () => {
			try {
				const response = await getCharacterTemplate(templateId);
				setTemplate(response);
			} catch (error) {
				console.error('Error getting character template', error);
			}
		};
		if (templateId) {
			fetchTemplate();
		}
	}, [templateId]);

	const handleSave = async () => {
		try {
			if (template.ID) {
				const updated = await updateCharacterTemplate(template);
				setTemplate(updated);
			} else {
				const created = await createCharacterTemplate(template);
				setTemplate(created);
			}
		} catch (err) {
			console.error('Save failed:', err);
		}
	};

	const loadAlienTemplate = () => {
		setTemplate(createAlienTemplate());
	};

	return (
		<Grid container spacing={2}>
			<Grid item xs={12}>
				<Box display="flex" justifyContent="space-between" alignItems="center">
					<Box>
						<Typography variant="h6">Official Templates</Typography>
						<Typography variant="body2" color="text.secondary">
							Load a curated system template, then edit or save it as a normal character
							template.
						</Typography>
					</Box>
					<Button variant="outlined" onClick={loadAlienTemplate}>
						Load Alien Template
					</Button>
				</Box>
			</Grid>
			<Grid item xs={6}>
				<Template template={template} setTemplate={setTemplate} />
			</Grid>
			<Grid item xs={6}>
				<TemplateBuilder template={template} setTemplate={setTemplate} />
			</Grid>
			<Grid item xs={12}>
				<Button variant="contained" color="primary" onClick={handleSave}>
					Save Template
				</Button>
			</Grid>
		</Grid>
	);
};

export default CharacterTemplate;
